import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {firstValueFrom} from 'rxjs';
import {map} from 'rxjs/operators';
import {JsonApiResponse} from '../models/JsonApiResponse';

@Injectable({
  providedIn: 'root'
})
export class DocumentationService {

  constructor(private readonly http: HttpClient) {
  }

  getDocumentationUrl() {
    return firstValueFrom(
      this.http
        .get<JsonApiResponse<string>>(`${environment.services.service}v1/documentation/url`)
        .pipe(
          map(response => response.data)
        )
    )
  }
}
